import { format } from 'owa-string-utils';
import { getLocalizedString } from 'owa-timeformat/lib/localization/getLocalizedString';
import { addDays, OwaDate } from 'owa-datetime';
import DailyRecurrence from 'owa-service/lib/contract/DailyRecurrence';
import RecurrencePatternHandler from './RecurrencePatternHandler';

function formatRecurrence(pattern: DailyRecurrence): string {
    if (pattern.Interval === 1) {
        return getLocalizedString('calendarDaily1Recurrence');
    } else if (pattern.Interval === 2) {
        return getLocalizedString('calendarDaily2Recurrence');
    } else {
        return format(getLocalizedString('calendarDailyNRecurrence'), pattern.Interval);
    }
}

function canHandle(pattern: DailyRecurrence): boolean {
    return pattern.__type === 'DailyRecurrence:#Exchange' && !!pattern.Interval;
}

function getNumberedRecurrenceEndDate(
    pattern: DailyRecurrence,
    start: OwaDate,
    numberOfOccurrences: number
) {
    return addDays(start, (numberOfOccurrences - 1) * pattern.Interval);
}

let handler: RecurrencePatternHandler = {
    canHandle: canHandle,
    formatRecurrence: formatRecurrence,
    formatRecurrenceOption: formatRecurrence,
    getNumberedRecurrenceEndDate: getNumberedRecurrenceEndDate,
    formatOptionsForSummary: formatRecurrence,
};

export default handler;
